import React from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../components/CustomHook';
import { Link } from 'react-router-dom';
import bianca from '../images/people/bianca.jpg';
import steve from '../images/people/steve.jpg';
import shawn from '../images/people/shawn.jpg';
import theyva from '../images/people/theyva.jpg';

const AboutUs = () => {
    useDocTitle('About Us - Claravio Solutions');

    return (
        <>
            <NavBar />
            <div className="bg-gray-50 min-h-screen pt-28">
                
                {/* Section 1: Who We Are */}
                <section className="min-h-screen flex flex-col">
                    {/* Hero Section - matching Process Improvement style */}
                    <div className="bg-claravio-blue-900 text-white py-20">
                        <div className="container mx-auto px-4 text-center">
                            <h1 className="text-4xl lg:text-6xl font-bold mb-4">About Us</h1>
                            <p className="text-xl lg:text-2xl mb-8">Operational excellence through proven expertise and innovative solutions</p>
                        </div>
                    </div>
                    
                    <div className="container mx-auto px-4 py-16 flex-1 flex items-center justify-center">

                        {/* Who We Are Content */}
                        <div className="max-w-4xl mx-auto text-center">
                            <h2 className="text-4xl font-bold text-gray-800 mb-8">Who We Are</h2>
                            <div className="w-24 h-1 bg-claravio-blue-900 mx-auto mb-8"></div>
                            
                            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                                <p>
                                    Claravio is an Operational Improvement firm providing custom software and 
                                    consulting services. We have a proven approach to help clients reduce costs, increase
                                    revenue and improve the overall quality of service they deliver.
                                </p>
                                
                                <p>
                                    We specialize in quickly identifying improvement opportunities and developing 
                                    solutions (system and process) that significantly improve operational performance and financal results.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Section 2: Changing the Traditional Mindset / Our Philosophy */}
                <section className="min-h-screen flex items-center justify-center bg-white">
                    <div className="container mx-auto px-4">
                        <div className="max-w-4xl mx-auto text-center">
                            <h2 className="text-4xl font-bold text-gray-800 mb-8">Changing the Traditional Approach</h2>
                            <div className="w-24 h-1 bg-claravio-blue-900 mx-auto mb-12"></div>
                            
                            <div className="space-y-8 text-lg text-gray-700 leading-relaxed">
                                
                               <p className="text-xl text-claravio-blue-900 font-semibold"> 
                                    At Claravio, we believe there is a better way to successfully deliver financial and operational 
                                    initiatives. The market is changing and so should the traditional approach regarding the 
                                    delivery of services towards your goals.
                                </p>
                                
                                <p>
                                    We bring a servant leadership approach coupled with an unparalleled commitment execution dicipline  
                                    to deliver on your critical initiatives.
                                </p>
                            </div>
                            
                            {/* Values Grid */}
                            <div className="grid md:grid-cols-3 gap-8 mt-16">
                                <div className="bg-blue-50 p-6 rounded-lg">
                                    <div className="text-claravio-blue-900 mb-4">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 1L9 9l-8 0 6.5 4.7L5 22l7-5 7 5-2.5-8.3L23 9l-8 0z"/>
                                        </svg>
                                    </div>
                                    <h3 className="font-semibold text-lg text-gray-800 mb-2">Trust & Integrity</h3>
                                    <p className="text-gray-600">Building lasting relationships through ethical behavior and transparency</p>
                                </div>
                                
                                <div className="bg-blue-50 p-6 rounded-lg">
                                    <div className="text-claravio-blue-900 mb-4">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zM4 1v6h6L8.5 5.5 10 4h5v2h-3l1 1 3.25 3.25c.31.31.69.5 1.06.69L18 12h4v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h6L8.5 2.5 4 1z"/>
                                        </svg>
                                    </div>
                                    <h3 className="font-semibold text-lg text-gray-800 mb-2">Collaboration</h3>
                                    <p className="text-gray-600">Working together to achieve shared goals and sustainable results</p>
                                </div>
                                
                                <div className="bg-blue-50 p-6 rounded-lg">
                                    <div className="text-claravio-blue-900 mb-4">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                                        </svg>
                                    </div>
                                    <h3 className="font-semibold text-lg text-gray-800 mb-2">Innovation</h3>
                                    <p className="text-gray-600">Bringing creative solutions and fresh perspectives to every challenge</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Section 3: Proven Track Record */}
                <section className="min-h-screen flex items-center justify-center bg-gray-50">
                    <div className="container mx-auto px-4">
                        <div className="max-w-4xl mx-auto text-center">
                            <h2 className="text-4xl font-bold text-claravio-blue-900 mb-8">Proven Track Record of Success</h2>
                            <div className="w-24 h-1 bg-claravio-blue-900 mx-auto mb-12"></div>
                            
                            <div className="space-y-8 text-lg text-gray-700 leading-relaxed mb-16">
                                <p>
                                    Claravio specializes in providing operational improvements to businesses in a variety of 
                                    industries.
                                </p>
                                
                                <p>
                                    Our owners and core team have extensive operational experience (client-side of the 
                                    table) and have built a firm focused on delivering practical solutions and tangible 
                                    results. This unique client perspective allows us to build close relationships with 
                                    clients that are mutually rewarding.
                                </p>
                            </div>

                            {/* Experience Highlights */}
                            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
                                <div className="text-center">
                                    <div className="text-4xl font-bold text-claravio-blue-900 mb-2">100+</div>
                                    <p className="text-gray-600">Years of CombinedExperience</p>
                                </div>
                                <div className="text-center">
                                    <div className="text-4xl font-bold text-claravio-blue-900 mb-2">200+</div>
                                    <p className="text-gray-600">Projects Delivered</p>
                                </div>
                                <div className="text-center">
                                    <div className="text-4xl font-bold text-claravio-blue-900 mb-2">10+</div>
                                    <p className="text-gray-600">Industry Sectors</p>
                                </div>
                            </div>

                            {/* Industry Experience 
                                    Healthcare
                                    Financial Services
                                    Technology
                                    Energy
                                    Entertainment
                                    Retail and E-commerce
                                    Manufacturing
                                    Airline
                                    Automotive
                                    Telecommunications
                                    Government
                                    Food and Beverage
                            
                            */}
                            <div className="bg-white p-8 rounded-lg shadow-lg">
                                <h3 className="text-2xl font-semibold text-gray-800 mb-6">Industries We Serve</h3>
                                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 text-left">
                                    <div className="flex items-center space-x-2">
                                        <span className="w-2 h-2 bg-claravio-blue-900 rounded-full"></span>
                                        <span className="text-gray-700">Healthcare</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <span className="w-2 h-2 bg-claravio-blue-900 rounded-full"></span>
                                        <span className="text-gray-700">Financial Services</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <span className="w-2 h-2 bg-claravio-blue-900 rounded-full"></span>
                                        <span className="text-gray-700">Technology</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <span className="w-2 h-2 bg-claravio-blue-900 rounded-full"></span>
                                        <span className="text-gray-700">Energy</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <span className="w-2 h-2 bg-claravio-blue-900 rounded-full"></span>
                                        <span className="text-gray-700">Entertainment</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <span className="w-2 h-2 bg-claravio-blue-900 rounded-full"></span>
                                        <span className="text-gray-700">Retail & E-commerce</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <span className="w-2 h-2 bg-claravio-blue-900 rounded-full"></span>
                                        <span className="text-gray-700">Airline</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <span className="w-2 h-2 bg-claravio-blue-900 rounded-full"></span>
                                        <span className="text-gray-700">Automotive</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <span className="w-2 h-2 bg-claravio-blue-900 rounded-full"></span>
                                        <span className="text-gray-700">Telecommunications</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <span className="w-2 h-2 bg-claravio-blue-900 rounded-full"></span>
                                        <span className="text-gray-700">Government</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <span className="w-2 h-2 bg-claravio-blue-900 rounded-full"></span>
                                        <span className="text-gray-700">Food & Beverage</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Section 4: Our Leadership Team */}
                <section className="min-h-screen flex items-center justify-center bg-white py-20">
                    <div className="container mx-auto px-4">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl font-bold text-gray-800 mb-8">Our Leadership Team</h2>
                            <div className="w-24 h-1 bg-claravio-blue-900 mx-auto"></div>
                        </div>

                        <div className="grid lg:grid-cols-4 gap-12 max-w-6xl mx-auto">
                            {/* Shawn Coffman - CEO */}
                            <div className="text-center">
                                <div className="relative mb-6">
                                    <div className="w-64 h-64 mx-auto bg-gray-300 rounded-lg overflow-hidden shadow-lg">
                                        <img src={shawn} alt="Shawn Coffman" className="w-full h-full object-cover object-top"/>
                                     
                                    </div>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800 mb-2">Shawn Coffman</h3>
                                <p className="text-lg text-claravio-blue-900 mb-4">CEO</p>
                                <p className="text-gray-600 leading-relaxed">
                                    Shawn brings executive leadership experience in operational improvement 
                                    and strategic transformation across multiple industries. 
                                </p>
                            </div>

                            {/* Steve Laughlin - CTO */}
                            <div className="text-center">
                                <div className="relative mb-6">
                                    <div className="w-64 h-64 mx-auto bg-gray-300 rounded-lg overflow-hidden shadow-lg">
                                        <div className="w-full h-full bg-gradient-to-br from-gray-400 to-gray-500 flex items-center justify-center">
                                           <img src={steve} alt="Steve Laughlin" className="w-full h-full object-cover object-top"/>
                                        </div>
                                    </div>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800 mb-2">Steve Laughlin</h3>
                                <p className="text-lg text-claravio-blue-900 mb-4">CTO</p>
                                <p className="text-gray-600 leading-relaxed">
                                    Steve leads our technology initiatives with deep expertise in software development, 
                                    system architecture, and digital transformation strategies.
                                </p>
                            </div>

                            {/* Theyva Johansson - CFO */}
                            <div className="text-center">
                                <div className="relative mb-6">
                                    <div className="w-64 h-64 mx-auto bg-gray-300 rounded-lg overflow-hidden shadow-lg">
                                        <div className="w-full h-full bg-gradient-to-br from-gray-400 to-gray-500 flex items-center justify-center">
                                            <img src={theyva} alt="Theyva" className="w-full h-full object-cover object-top"/>
                                        </div>
                                    </div>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800 mb-2">Theyva Johansson</h3>
                                <p className="text-lg text-claravio-blue-900 mb-4">CFO</p>
                                <p className="text-gray-600 leading-relaxed">
                                    Theyva oversees financial strategy and operations, ensuring sustainable growth and 
                                    optimal resource allocation for client success.
                                </p>
                            </div>

                            {/* Bianca Cox - COO */}
                            <div className="text-center">
                                <div className="relative mb-6">
                                    <div className="w-64 h-64 mx-auto bg-gray-300 rounded-lg overflow-hidden shadow-lg">
                                        <div className="w-full h-full bg-gradient-to-br from-gray-400 to-gray-500 flex items-center justify-center">
                                            <img src={bianca} alt="Bianca Cox" className="w-full h-full object-cover object-top"/>
                                        </div>
                                    </div>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800 mb-2">Bianca Cox</h3>
                                <p className="text-lg text-claravio-blue-900 mb-4">COO</p>
                                <p className="text-gray-600 leading-relaxed">
                                    Bianca creates operational strategies and ensures seamless execution across all departments. 
                                    Her expertise in process optimization drives efficiency and excellence.
                                </p>
                            </div> 
                        </div>

                        {/* Call to Action */}
                        <div className="text-center mt-16">
                            <div className="bg-claravio-blue-900 text-white p-8 rounded-lg">
                                <h3 className="text-2xl font-bold mb-4">Ready to Work with Our Team?</h3>
                                <p className="text-lg mb-6">Let's discuss how Claravio can help transform your operations and drive sustainable growth.</p>
                                <Link to="/contact" className="bg-white text-claravio-blue-900 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition duration-300">
                                    Contact Our Leadership Team
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    );
};

export default AboutUs;